import script from "./LootBoxApeInfoCounter.vue?vue&type=script&setup=true&lang=js"
export * from "./LootBoxApeInfoCounter.vue?vue&type=script&setup=true&lang=js"

import "./LootBoxApeInfoCounter.vue?vue&type=style&index=0&id=369f7477&lang=scss"

const __exports__ = script;

export default __exports__